var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInternal = function SvgInternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.382 5.28c7.777 0 14.083 6.306 14.083 14.085 0 7.779-6.306 14.085-14.083 14.085C6.6 33.453.295 27.143.295 19.365.295 11.587 6.6 5.28 14.382 5.28Z",
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.38 14.085c-3.026 0-5.479 2.425-5.479 5.416 0 2.991 2.453 5.416 5.48 5.416 3.026 0 5.479-2.425 5.479-5.416 0-2.991-2.453-5.416-5.48-5.416Zm-6.563 5.416c0-3.583 2.939-6.487 6.563-6.487 3.625 0 6.564 2.904 6.564 6.487s-2.939 6.487-6.563 6.487c-3.625 0-6.564-2.904-6.564-6.487Zm6.563-2.916c.3 0 .542.24.542.535v3.468l1.484-1.466a.546.546 0 0 1 .766 0 .531.531 0 0 1 0 .758l-2.408 2.38a.547.547 0 0 1-.767 0l-2.408-2.38a.531.531 0 0 1 0-.758.546.546 0 0 1 .766 0l1.484 1.466V17.12c0-.296.242-.535.541-.535Z",
    fill: "#0086C9"
  })));
};

export default SvgInternal;